import type { RouteRecordRaw } from 'vue-router'
import { REGIONS } from '@/config/regions'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/views/home/index.vue'),
    meta: { title: '首页' },
  },
  {
    path: '/home',
    redirect: '/',
  },
  {
    path: '/about',
    component: () => import('@/views/about/index.vue'),
    meta: { title: '关于我们', public: true },
  },
  {
    path: '/faq',
    component: () => import('@/views/home/faq.vue'),
    meta: { title: '常见问题', public: true },
  },
  {
    path: '/privacy',
    component: () => import('@/views/privacy/index.vue'),
    meta: { title: '隐私政策', public: true },
  },
  {
    path: '/terms',
    component: () => import('@/views/terms/index.vue'),
    meta: { title: '用户协议', public: true },
  },
  {
    path: '/login',
    component: () => import('@/views/auth/login.vue'),
    meta: { title: '登录', public: true },
  },
  {
    path: '/course/list',
    component: () => import('@/views/course/list.vue'),
    meta: { title: '球场列表', public: true },
  },
  {
    path: '/course/detail/:golfId',
    component: () => import('@/views/course/detail.vue'),
    meta: { title: '球场详情', public: true },
  },
  {
    path: `/course/:region(${REGIONS.map(r => r.slug).join('|')})`,
    component: () => import('@/views/course/region.vue'),
    meta: { title: '球场预订', public: true },
  },
  {
    path: '/hotel/list',
    component: () => import('@/views/hotel/list.vue'),
    meta: { title: '酒店列表', public: true },
  },
  {
    path: '/hotel/detail/:hotelId',
    component: () => import('@/views/hotel/detail.vue'),
    meta: { title: '酒店详情', public: true },
  },
  {
    path: '/hotel/order',
    component: () => import('@/views/hotel/order.vue'),
    meta: { title: '确认订单', requiresAuth: true },
  },
  {
    path: '/college/list',
    component: () => import('@/views/college/list.vue'),
    meta: { title: '高尔夫学院', public: true },
  },
  {
    path: '/college/detail/:id',
    component: () => import('@/views/college/detail.vue'),
    meta: { title: '学院详情', public: true },
  },
  {
    path: '/college/lesson/:id',
    component: () => import('@/views/college/lesson.vue'),
    meta: { title: '私教课程详情', public: true },
  },
  {
    path: '/college/order/:id',
    component: () => import('@/views/college/order.vue'),
    meta: { title: '确认订单', requiresAuth: true },
  },
  {
    path: '/shop/list',
    component: () => import('@/views/shop/list.vue'),
    meta: { title: '高尔夫专卖店', public: true },
  },
  {
    path: '/shop/detail/:id',
    component: () => import('@/views/shop/detail.vue'),
    meta: { title: '专卖店详情', public: true },
  },
  {
    path: '/shop/goods/:id',
    component: () => import('@/views/shop/goods.vue'),
    meta: { title: '商品详情', public: true },
  },
  {
    path: '/shop/order/:id',
    component: () => import('@/views/shop/order.vue'),
    meta: { title: '确认订单', requiresAuth: true },
  },
  {
    path: '/scenic/list',
    component: () => import('@/views/scenic/list.vue'),
    meta: { title: '景点列表', public: true },
  },
  {
    path: '/scenic/detail/:scenicId',
    component: () => import('@/views/scenic/detail.vue'),
    meta: { title: '景点详情', public: true },
  },
  {
    path: '/restaurant/list',
    component: () => import('@/views/restaurant/list.vue'),
    meta: { title: '餐厅列表', public: true },
  },
  {
    path: '/restaurant/detail/:restaurantId',
    component: () => import('@/views/restaurant/detail.vue'),
    meta: { title: '餐厅详情', public: true },
  },
  {
    path: '/setmeal/list',
    component: () => import('@/views/setmeal/list.vue'),
    meta: { title: '精选套餐', public: true },
  },
  {
    path: '/setmeal/detail/:setmealId',
    component: () => import('@/views/setmeal/detail.vue'),
    meta: { title: '套餐详情', public: true },
  },
  {
    path: '/booking/confirm',
    component: () => import('@/views/booking/confirm.vue'),
    meta: { title: '确认订单', requiresAuth: true },
  },
  {
    path: '/booking/setmeal-confirm',
    component: () => import('@/views/booking/setmeal-confirm.vue'),
    meta: { title: '套餐确认订单', requiresAuth: true },
  },
  {
    path: '/payment',
    component: () => import('@/views/payment/index.vue'),
    meta: { title: '支付', requiresAuth: true },
  },
  {
    path: '/payment/result',
    component: () => import('@/views/payment/result.vue'),
    meta: { title: '支付结果', requiresAuth: true },
  },
  {
    path: '/order/list',
    component: () => import('@/views/order/list.vue'),
    meta: { title: '我的订单', requiresAuth: true },
  },
  {
    path: '/order/detail/:orderId',
    component: () => import('@/views/order/detail.vue'),
    meta: { title: '订单详情', requiresAuth: true },
  },
  {
    path: '/order/setmeal-detail/:orderCode',
    component: () => import('@/views/order/setmeal-detail.vue'),
    meta: { title: '套餐订单详情', requiresAuth: true },
  },
  {
    path: '/order/hotel-detail/:orderId',
    component: () => import('@/views/order/hotel-detail.vue'),
    meta: { title: '酒店订单详情', requiresAuth: true },
  },
  {
    path: '/merchant/claim',
    component: () => import('@/views/merchant/claim.vue'),
    meta: { title: '商家入驻', public: true },
  },
  {
    path: '/user/profile',
    component: () => import('@/views/user/profile.vue'),
    meta: { title: '个人中心', requiresAuth: true },
  },
  {
    path: '/user/edit',
    component: () => import('@/views/user/edit.vue'),
    meta: { title: '编辑资料', requiresAuth: true },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

export default routes
